/*=========================================================================================
  File Name: ticket.js
  Description: Ticket
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './ticketState.js'
import mutations from './ticketMutations.js'
import actions from './ticketActions.js'
import getters from './ticketGetters.js'

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}